import { ActionContext, IActionContext } from '../../ts/helpers/ActionContext';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';
import { Set } from '../../ts/models/Set';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from '../../ts/services/ConfirmActionDialog';
import { ContentActionNotification } from './ContentActionNotification';

/**
 * @deprecated This is used in only a handful of actions. It involves Angular, and inheritance isn't
 * a great pattern anyway. It could be migrated to React, or just actions can use some other pattern.
 * If anyone makes a replacement for this, please list it here, otherwise we can delete it when there
 * are no more usages.
 */
export abstract class AbstractContentAction<TContentItem extends INamedItemInfo> {

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog) { }

  public executeFromEvent(contentItems: Set<TContentItem>, $event: JQueryEventObject): ng.IPromise<IResult> {
    return this.execute(contentItems, ActionContext.fromEvent($event));
  }

  public execute(contentItems: Set<TContentItem>, actionContext: IActionContext): ng.IPromise<IResult> {

    const dialogConfig = this.defaultDialogConfig(actionContext);
    this.configureDialog(dialogConfig, contentItems);

    const dialogInstance = this.ConfirmActionDialog.open(dialogConfig);

    dialogInstance.result.then((result: IResult) => {
      const translationFns = this.notificationTranslationFns();
      ContentActionNotification.displaySingleToastForResult({
        items: contentItems,
        errors: result.errors,
        successMsg: translationFns.successMsg,
        errorMsg: translationFns.errorMsg,
      });
    });

    dialogInstance.result.finally(() => dialogConfig.scope.$destroy());
    return dialogInstance.result;
  }

  private defaultDialogConfig(actionContext: IActionContext): IConfirmActionDialogOptions {
    return {
      scope: actionContext.scope.$new(),
      title: '',
      actionName: 'OK',
      action: angular.noop
    };
  }

  // Override in action implementations
  configureDialog(dialogConfig: IConfirmActionDialogOptions, contentItems: Set<TContentItem>) {}

  abstract notificationTranslationFns(): {
    successMsg: (inputs: { successCount: number }) => string;
    errorMsg: (inputs: { errorCount: number }) => string;
  };

}
